"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendEmailData = exports.getMeterReadDate = exports.default = exports.activateOko = void 0;
var _mainConfig = require("../mainConfig");
var _meterReadingApi = require("../cic/api/meterReadingApi");
var _meterReadingApi2 = require("../csc/api/meterReadingApi");
var currentApiSet = _mainConfig.isCICContentTree ? {
  getMeterReadDate: _meterReadingApi.getMeterReadDate,
  sendEmailData: _meterReadingApi.sendEmailData,
  activateOko: _meterReadingApi.activateOko
} : {
  getMeterReadDate: _meterReadingApi2.getMeterReadDate,
  sendEmailData: _meterReadingApi2.sendEmailData
};
var getMeterReadDate = exports.getMeterReadDate = currentApiSet.getMeterReadDate,
  sendEmailData = exports.sendEmailData = currentApiSet.sendEmailData,
  activateOko = exports.activateOko = currentApiSet.activateOko;
var _default = exports.default = currentApiSet;